module.exports = "<cat-growl\n  [(value)]=\"messages\"\n  [(life)]=\"timeToLife\"\n  [baseZIndex]=\"baseZIndex\"\n  (onClose)=\"onClose($event)\"\n></cat-growl>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/components/notifications/notifications.component.html
// module id = ../../../../../src/app/modules/core/components/notifications/notifications.component.html
// module chunks = main